module.exports = __webpack_public_path__ + "img/locations-add.bd564079.svg";